import { D3ChartComponentLookup, type D3ChartNames } from '@revelio/d3';
import { DivergingBarChart, ReplotChartNames } from '@revelio/replots';

export const deriveSharedChartType = (
  Component: unknown
): D3ChartNames | undefined => {
  // Match against D3ChartComponentLookup values.
  for (const [key, value] of Object.entries(D3ChartComponentLookup)) {
    if (value === Component) {
      return key as D3ChartNames;
    }
  }

  if (Component === DivergingBarChart) {
    return ReplotChartNames.DivergingBarChart as unknown as D3ChartNames;
  }

  return undefined;
};
